import $ from 'jquery';
import BaseComponent from '../../../general/js/base-component';
import stylesFinally from '../../../general/js/style-observer'

export default class LatestNewsComponent extends BaseComponent {
    constructor() {
        super(...arguments);

        this.$elemet = $(this.element);

        this.defaultOptions = {
            loop: true,
            nav: true,
            dots: false,
            margin: 29,
            navText: [
                '<svg class="icon" width="10" height="20"><use xlink:href="#icon-arrow-left"></use></svg>',
                '<svg class="icon" width="10" height="20"><use xlink:href="#icon-arrow-right"></use></svg>'
            ],
            responsive: {
                0: {
                    items: 1,
                },
                769: {
                    items: 3,
                    nav: false,
                    loop: false,
                },
            }
        };
        stylesFinally(() => {
            this.init();
        })
    }

    init() {
        let options = {...this.defaultOptions, ...this.options};
        this.$elemet.owlCarousel(options);
    }

    onDestroy() {
        this.$elemet.owlCarousel('destroy');
    }
}



// WEBPACK FOOTER //
// ./app/components/latest-news/js/latest-news.component.js